import { Container, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import Page from 'src/components/molecules/page';
import { PhotoStudioInputForm } from 'src/components/organisms/photo-studio/form';

export const PhotoStudioCreatePage: FC = () => {
  /* 定数宣言 */
  const title = '店舗登録';

  return (
    <Page title={title}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {title}
          </Typography>
        </Stack>
        <PhotoStudioInputForm />
      </Container>
    </Page>
  );
};
